import React, { useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useCookies } from 'react-cookie';
import { BiHide, BiShowAlt } from 'react-icons/bi';
import { Link, useNavigate } from 'react-router-dom';

const Login = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [loading, setLoading] = useState(false); // New state variable for loading state
  const [invalidLogin, setinvalidLogin]=useState(false)
  const [showPassword, setShowPassword] = useState(false);
  const [verifyEmail, setVerifyEmail] = useState(false);
  const [loginError, setLoginError]=useState('')

  const [cookies, setCookie] = useCookies(['token']);
   //ttps://campus-closet-server.vercel.app/  This is the hosted server url
   //ttp://localhost:8000/ This is Local server url

    // Toggle password visibility for main password input field
  const toggleShowPassword = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };
  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      setLoading(true); // Set loading state to true

      const response = await fetch('https://campus-closet-server.vercel.app/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });

      if (response.ok) {
        toast.success('Login successful!', {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000
        });
        const data = await response.json();
        const token = data.token;
        setCookie('token', token, { path: '/' }); // Store the token in a cookie
        setTimeout(() => {
          navigate('/');
        }, 1000); // Delay of 3000 milliseconds (3 seconds)
      }  else if (response.status === 401) {
        const data = await response.json();
        const err=data.error
        console.error(err);
        // Handle the wrong data login error
        setinvalidLogin(true)
        setLoginError(err)
        setTimeout(()=>{
          setinvalidLogin(false)
        },2000)
        toast.error(err, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        })}  else if (response.status === 403) {
          // Handle the "User has not verified Email" error
          setVerifyEmail(true)
          setTimeout(()=>{
            setVerifyEmail(false)
          },7000)
          toast.error('User has not verified Email', {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
          })} else{
        toast.error('Login failed! Try again later', {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000
        });
      }
    } catch (error) {
      console.error('An error occurred:', error);
      // Handle any errors
    } finally {
      setLoading(false); // Set loading state back to false
    }
  };

  const handleChange = (event) => {
    setFormData({
      ...formData,
      [event.target.name]: event.target.value
    });
  };

  return (
    <section className="bg-gray-50">
      <div className="auth-forms flex flex-col items-center justify-center px-6 py-8 mx-auto lg:py-0">
        <div className="form w-full bg-white rounded-lg shadow dark:border md:mt-0 sm:max-w-md xl:p-0 ">
          <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
            <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl">
              Login into your account
            </h1>
            <form className="space-y-4 md:space-y-6 h-auto" onSubmit={handleSubmit}>
              <div>
                <label
                  htmlFor="email"
                  className="block mb-2 text-sm font-medium text-gray-900"
                >
                  Your email
                </label>
                <input
                  type="email"
                  name="email"
                  id="email"
                  className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5"
                  placeholder="name@company.com"
                  required
                  value={formData.email}
                  onChange={handleChange}
                />
              </div>
              <div>
                <div className='flex justify-between'>
                <label
                  htmlFor="password"
                  className="block mb-2 text-sm font-medium text-gray-900"
                >
                  Password
                </label>
                <p
                  className="block mb-2 text-sm font-medium text-blue-600 cursor-pointer"
                  onClick={()=>navigate('/password_reset')}
                >
                  forgot password?
                </p>
                </div>
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  id="password"
                  placeholder="••••••••"
                  className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:focus:border-blue-500"
                  required
                  value={formData.password}
                  onChange={handleChange}
                />
                {/* show or hide password */}
              <div
                  className='mt-[-27px]  ml-[90%]'
                    onClick={toggleShowPassword}
                  >
                    {showPassword ? <BiHide /> : <BiShowAlt />}
              </div>
              </div>
              <button
                type="submit"
                className={`w-full text-gray-900 bg-blue-400 hover:bg-blue-500 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center ${
                  loading ? 'opacity-50 cursor-not-allowed' : ''
                }`}
                >
                  {/* Change button text to "Loading..." when loading is true */}
                {loading ? 'Loading...' : 'Login'} 
              </button>
              <p className="text-sm font-light text-gray-500 dark:text-gray-900">
                Don't have an account?{' '}
                <Link
                  to="/register"
                  className="font-medium text-primary-600 hover:underline dark:text-primary-500"
                >
                  Register here
                </Link>
              </p>
               {invalidLogin &&  <p className='text-red-600 '>{loginError}</p>}
               {verifyEmail &&  <p className='text-red-600 '>Your Email is not Verified, please verify by the link sent to your email before login.</p>}
            </form>
          </div>
        </div>
      </div>
      <ToastContainer />
    </section>
  );
};

export default Login;
